<h1 mat-dialog-title>Fehler beim Generieren der Verbrauchsdaten</h1>
<mat-dialog-content>
  <div class="icon-bar">
    <mat-icon class="ok">login</mat-icon>
    <div class="dots">
      <div *ngFor="let d of cDots" class="dot"></div>
    </div>
    <mat-icon class="fail">receipt_long</mat-icon>
  </div>

  <p>
    Ihr Zugang funktioniert und Sie haben sich erfolgreich angemeldet.<br>
    Leider ist bei der Generierung der Verbrauchsdaten auf unserer Seite ein Fehler aufgetreten.<br>
    Eventuell liegen für Sie noch keine Verbrauchsdaten vor. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.
  </p>

</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button (click)="close()" cdkFocusInitial>Schließen</button>
</div>
